import { Modal } from 'antd';

import styles from './index.module.scss';
import { closeIcon } from '../../assets/ImageCreation';
import { LocalImage } from '../Image';
export interface INotifyModalProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  descriptions: string[];
  okText: string;
}

export function NotifyModal(props: INotifyModalProps) {
  const { visible, onClose, title, descriptions, okText } = props;
  const isList = descriptions.length > 1;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      closeIcon={null}
      footer={null}
      classNames={{ content: styles.modal }}
      centered
    >
      <div className={styles.container}>
        <div className={styles.close} onClick={onClose}>
          <LocalImage src={closeIcon} />
        </div>
        <div className={styles.title}>{title}</div>
        {isList ? (
          <ul className={styles.descriptionList}>
            {descriptions.map((description) => (
              <li className={styles.description}>{description}</li>
            ))}
          </ul>
        ) : (
          <div className={styles.description}>{descriptions[0]}</div>
        )}
        <div className={styles.okText} onClick={onClose}>
          {okText}
        </div>
      </div>
    </Modal>
  );
}
